import React, { useState, useContext, useEffect, useRef } from 'react';
import '../Styles/Header.scss';
import Logo from '../Images/ht_logo_final.png';
import MenuMobile from './MenuMobile';
import { MenuContext } from '../Contexts/MenuContext';
import { GlobalContext } from '../Contexts/GlobalContext';
import Modal from './Modal';
import PasswordChanger from './PasswordChanger';
import { deleteCookie } from '../Util/Cookie';
import { useHistory } from 'react-router-dom';
import GuiLanguageSelector from './MultiLanguage/GuiLanguageSelector';
import useGuiTranslations from './MultiLanguage/useGuiTranslations';
//import useFreshWorks from '../CustomHooks/useFreshWorks';
import useTawk from '../CustomHooks/useTawk';

function Header() {
  const [menuOpenState, setMenuOpenState] = useState(false);
  //const [menuContext, setMenuCon] = useContext(MenuContext);
  const globalContext = useContext(GlobalContext);
  const [changePasswordOn, setChangePasswordOn] = useState(false);
  const [headerMenuOn, setHeaderMenuOn] = useState(false);
  const wrapperRef = useRef(null);
  const history = useHistory();
  const [translateGui] = useGuiTranslations();
  //const nullValue = useFreshWorks();
  const nullValue = useTawk();

  useEffect(() => {
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  });

  

  function handleClickOutside(event) {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      console.log("You clicked outside of me!");
      setHeaderMenuOn(false);
    }
  }

  const signOut = () => {
    //delete cookie or set the expiry time to zero
    deleteCookie();
    //and send the log on
    //window.location = '/Login';
    //console.log(globalContext.globalState.selectedGuiLanguage);
    let loginUrl = '/Login' + (globalContext.globalState.selectedGuiLanguage=='tr'? '?lang=tr' : '') ; 
    //console.log(loginUrl);
    history.push(loginUrl);
  }

  return (
    <React.Fragment>
      <div className="header">

        <span className="logo-span">
          <img style={{ width: '150px', marginLeft: '25px', alignSelf: 'center' }} src={Logo}></img>
        </span>
        <div className="header__outer-wrapper">
          <div className="header__inner-wrapper">
            
            

            <div className="header__user-wrapper" style={{ display: 'flex' }}>
              <span className="header__user-email" >{globalContext.globalState.email}</span>
              <i className="material-icons" style={{ color: 'rgb(65, 65, 65, 0.76)', fontSize: '26px', cursor: 'pointer' }} onClick={() => { setHeaderMenuOn(true) }}>account_circle</i>
              {headerMenuOn ?
                <div className="header-menu__wrapper" ref={wrapperRef} style={{ display: 'hidden' }}>

                  <div className="header-menu__inner-wrapper">
                    <div className="header-menu__item" onClick={() => { setChangePasswordOn(true); setHeaderMenuOn(false) }}>
                      Change password
                    </div>
                    <div className="header-menu__item" onClick={signOut}>
                      Sign out
                    </div>
                  </div>
                </div>
                : null}
            </div>
          </div>
          <GuiLanguageSelector></GuiLanguageSelector>
        </div>
        <span className="hamburger-menu" onClick={() => { menuOpenState ? setMenuOpenState(false) : setMenuOpenState(true) }}>
          <i className="material-icons">menu</i>
        </span>
        {
          menuOpenState ?
            <MenuMobile closeMenu={() => setMenuOpenState(false)}></MenuMobile>
            : null
        }

      </div>
      {changePasswordOn ?
        <Modal viewModal={setChangePasswordOn}>
          <PasswordChanger></PasswordChanger>
        </Modal>
        : null}
    </React.Fragment>
  );
}

export default Header;
